
export class Criterio {
    criterioid: number = 0;
    competenciaid: number = 0;
    nombre: string = "";
    descripcion: string = "";
    orden!: number;
    activo: boolean = true;

    constructor(init?: Partial<Criterio>) {
        Object.assign(this, init);
    }
}
